module.exports = __webpack_public_path__ + "static/img/PK.9b7a0413.jpg";